module.exports = __webpack_public_path__ + "static/img/close.fa393364.png";